import api from '@/services/api/config';
import stueckliste from './stueckliste';

const path = 'v1/infra/artikel';

export default {
  search: (page, size, sort = null, desc = false, suche = null) => api.get(path, {
    params: {
      page, size, sort, desc, suche,
    },
  }),
  stueckliste,
  getOhneWep: (page, size, sort = null, desc = false, suche = null) => api.get(`${path}/ohne_wep`, {
    params: {
      page, size, sort, desc, suche,
    },
  }),
  getAnzahlOhneWep: (suche = null) => api.get(`${path}/ohne_wep/anzahl`, {
    params: {
      suche,
    },
  }),
  importOhneWep: () => api.post(`${path}/ohne_wep/import`),
};
